import React from "react";
import Slider from "react-slick";
import ProductCard from "./ProductCard";
import { SpiceDetails, DhoopDetails } from "../../Constants/productListConstant";
import "./ProductCardsContainer.css";

class ProductCardsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0,
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1200,
    };
    this.slider = null;
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  setSliderRef = (ref) => {
    this.slider = ref;
  };

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  afterChangeHandler = (current) => {
    this.setState({ currentSlide: current });
  };

  render() {
    const { maxItems = 24 } = this.props;
    const { currentSlide, windowWidth } = this.state;
    const conveyor = [...SpiceDetails, ...DhoopDetails];
    const featuredProducts = conveyor.slice(0, maxItems);

    let slidesToShow = 4;
    if (windowWidth <= 1200) slidesToShow = 3;
    if (windowWidth <= 992) slidesToShow = 2;
    if (windowWidth <= 768) slidesToShow = 1;

    const getHighlightedIndices = () => {
      if (slidesToShow >= 4) {
        const firstCenter = (currentSlide + 1) % featuredProducts.length;
        const secondCenter = (currentSlide + 2) % featuredProducts.length;
        return [firstCenter, secondCenter];
      } else if (slidesToShow === 3) {
        const center = (currentSlide + 1) % featuredProducts.length;
        return [center];
      } else if (slidesToShow === 2) {
        const firstCard = currentSlide % featuredProducts.length;
        const secondCard = (currentSlide + 1) % featuredProducts.length;
        return [firstCard, secondCard];
      } else {
        return [currentSlide];
      }
    };

    const highlightedIndices = getHighlightedIndices();

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      arrows: true,
      autoplay: false,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: "0px",
      className: "product-slider",
      initialSlide: 0,
      afterChange: this.afterChangeHandler,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            centerPadding: "0px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: "0px",
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: "0px",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: "0px",
            arrows: false,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerPadding: "0px",
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: "0px",
            arrows: false,
          },
        },
      ],
    };

    return (
      <div className="products-cards-container" style={{ padding: "30px 80px 60px", position: "relative" }}>
        <div className="products-cards-wrapper" style={{ position: "relative" }}>
          {/* Custom arrows positioned outside slider */}
          <button
            onClick={() => this.slider.slickPrev()}
            aria-label="Previous slide"
            style={{
              position: "absolute",
              left: "-60px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1000,
              width: "50px",
              height: "50px",
              border: "2px solid #ed3837",
              borderRadius: "50%",
              background: "white",
              color: "#ed3837",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              outline: "none",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#ed3837";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "white";
              e.target.style.color = "#ed3837";
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <button
            onClick={() => this.slider.slickNext()}
            aria-label="Next slide"
            style={{
              position: "absolute",
              right: "-60px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1000,
              width: "50px",
              height: "50px",
              border: "2px solid #ed3837",
              borderRadius: "50%",
              background: "white",
              color: "#ed3837",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              outline: "none",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#ed3837";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "white";
              e.target.style.color = "#ed3837";
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <Slider ref={this.setSliderRef} {...settings}>
            {featuredProducts.map((item, index) => {
              const isHighlighted = highlightedIndices.includes(index);

              return (
                <div key={item.productName} className={`slide-item ${isHighlighted ? "slide-item--highlighted" : ""}`}>
                  <ProductCard item={item} isHighlighted={isHighlighted} />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  }
}

export default ProductCardsContainer;



// WEBPACK FOOTER //
// ./src/components/ProductCards/ProductCardsContainer.js